import { CountryListPage } from "@/features/geolocation/page/CountryListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/country/")({
  component: CountryListPage,
});
